$(document).ready(function () {
  var $wrapper = $('[data-pdp-variant-modal]');
  var $openBtn = $('[data-pdp-variant-modal-open]')
  var $closeBtn = $('[data-php-variant-modal-close]')

  if ($wrapper.length) {
    $openBtn.on('click', function () {
      $wrapper.css("display", "flex")
        .hide()
        .fadeIn(500);
    });

    $closeBtn.on('click', function () {
      $wrapper.fadeOut(500);
    });

    // Close panel when clicking outside
    $(document).on('click', function(e) {
      if ($wrapper.is(':visible')) {
        if (!$(e.target).closest($wrapper).length) {
          if (!$(e.target).closest($openBtn).length) {
            $wrapper.fadeOut(500);
          }
        }
      }
    });
  
    $wrapper.on('click', function(e) {
      e.stopPropagation();
    });

  }
});


